import { Chip } from '@biq/apex-ui';
import React from 'react';
import { Box, Toolbar } from '@mui/material';
import { SdzSelector } from 'core/components';
import { useUserSettings } from '../../../../core';
import { AccountMenu } from './AccountMenu';
import { StyledAppBar, styles } from './header-helpers';
import { TrialProgressBar } from '../../../../core/components/trial-countdown-bar/trial-countdown-bar';

interface AppHeaderProps {
    open: boolean;
}

export const AppHeader = ({ open }: AppHeaderProps): React.JSX.Element => {
    const { getElevatedSystemWallet } = useUserSettings();
    const displayElevateUserSettings =
        getElevatedSystemWallet()?.elevated ?? false;

    return (
        <StyledAppBar position='fixed' open={open} sx={styles.appBar(open)}>
            <Toolbar sx={styles.toolBar}>
                <Box>
                    <SdzSelector />
                </Box>
                <Box sx={styles.trialCountdownContainer}>
                    <TrialProgressBar />
                </Box>
                <Box sx={styles.settingsContainer}>
                    {displayElevateUserSettings && (
                        <Chip
                            color={'secondary'}
                            variant={'outlined'}
                            size={'small'}
                            label={'Elevating'}
                            readOnly
                            sx={styles.elevatingChip}
                        />
                    )}
                    <AccountMenu />
                </Box>
            </Toolbar>
        </StyledAppBar>
    );
};
